import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { ShiftGroupService } from '../proxy/controlling/controllers/shift-group.service';

FieldBuilder.setNamespace('Controlling');

export const SHIFT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Shift.Name')
    .required()
    .minLength(2)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Shift.Code')
    .required()
    .minLength(1)
    .maxLength(2)
    .build(),
  FieldBuilder
    .time('startHour', 'Entity.Shift.StartHour')
    .required()
    .build(),
  FieldBuilder
    .time('endHour', 'Entity.Shift.EndHour')
    .required()
    .build(),
  FieldBuilder
    .checkbox('isVisibleInMobile', 'Entity.Shift.IsVisibleInMobile')
    .build(),
  FieldBuilder
    .checkbox('isNocturnal', 'Entity.Shift.IsNocturnal')
    .build(),
  FieldBuilder
    .checkbox('isProductive', 'Entity.Shift.IsProductive')
    .build(),
  FieldBuilder
    .number('breakTime', 'Entity.Shift.BreakTime')
    .required()
    .decimal(2,4)
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .build(),
  FieldBuilder
    .foreignKey('shiftGroupId', 'Entity.ShiftGroup', ShiftGroupService)
    .required()
    .displayFromNested('shiftGroup.name')
    .sortBy('shiftGroup.name')
    .build(),
];

export const SHIFT_CONFIG = {
  entityName: 'Shift',
  localizationKey: 'Controlling::Entity.Shift',
  fields: SHIFT_FIELDS,
  permission: 'ControllingCalendar.Shifts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
